import React, { PropsWithChildren } from 'react';
import { Spinner } from 'react-bootstrap';

import './index.scss';

export interface MobileListStateProps {
  loading: boolean;
  isEmpty: boolean;
  emptyMessage: string;
  infiniteScroll?: {
    fetchingMore: boolean;
    listEnded: boolean;
  };
}

export default function MobileListState({
  loading,
  isEmpty,
  emptyMessage,
  infiniteScroll,
  children,
}: PropsWithChildren<MobileListStateProps>) {
  if (loading) {
    return <Spinner className="d-block mx-auto my-5" animation="border" />;
  }

  if (isEmpty) {
    return <p className="mobile-list-empty">{emptyMessage}</p>;
  }

  return (
    <>
      <div className="mobile-list">{children}</div>

      {infiniteScroll && (
        <div className="mobile-list-footer">
          {infiniteScroll.fetchingMore && !infiniteScroll.listEnded && (
            <Spinner animation="border" size="sm" />
          )}
          {infiniteScroll.listEnded && (
            <span>Exibindo todos os itens disponíveis</span>
          )}
        </div>
      )}
    </>
  );
}
